import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import _ from 'lodash'

import bankStatementActions from '../../redux/bankStatements/actions'
import SelectSearchOrderPaymentDetail from "../../components/SelectSearchOrderPaymentDetail"

const {
    fetchOrderPaymentDetailThroughQuery
} = bankStatementActions

const VALUE_FROM_STATE = 'VALUE_FROM_STATE'

class SelectSearchOrderPaymentDetailContainer extends Component {
    static propTypes = {
        // Props from another component
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(undefined)]),

        // Inner props
        fetchOrderPaymentDetailThroughQuery: PropTypes.func.isRequired,
        orderPaymentDetailsEntities: ImmutablePropTypes.map.isRequired,
        orderPaymentDetails: ImmutablePropTypes.map,
        bankStatements: ImmutablePropTypes.map.isRequired
    }

    static defaultProps = {
        onChange: () => {},
        value: VALUE_FROM_STATE
    }

    constructor (props) {
        super(props)

        this.state = {
            value: props.value === VALUE_FROM_STATE ? undefined : props.value
        }
    }

    getOrderPaymentDetails () {
        const { orderPaymentDetailsEntities, bankStatements } = this.props

        return bankStatements.get('orderPaymentDetailItems', new List()).map((id) => {
            return orderPaymentDetailsEntities.get(_.toString(id), new Map())
        })
    }

    onChange = (orderId) => {
        const { onChange } = this.props

        onChange(orderId)
        this.setState({ value: orderId })
    }

    onSearch = (query) => {
        const { fetchOrderPaymentDetailThroughQuery } = this.props

        fetchOrderPaymentDetailThroughQuery(query)
    }

    render () {
        const {
            onChange,
            bankStatements,
            value: propValue,
            defaultSelect,
            ...restProps
        } = this.props
        const { value: stateValue } = this.state

        const value = propValue === VALUE_FROM_STATE ? stateValue : propValue
        return (
            <SelectSearchOrderPaymentDetail
                loading={bankStatements.get('loading', false)}
                onChange={this.onChange}
                onSearch={this.onSearch}
                defaultValue={defaultSelect}
                orderPaymentDetails={this.getOrderPaymentDetails().toJS()}
                value={value}
                {...restProps}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        orderPaymentDetailsEntities: state.getIn(['Entities', 'paymentDetails']),
        bankStatements: state.get('bankStatements')
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchOrderPaymentDetailThroughQuery
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectSearchOrderPaymentDetailContainer)
